
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
img {
  height:auto;
  width:100%;
  border-radius:0.75rem;
}
.bg-green .in-page-hero-title, .bg-green .in-page-hero-eyebrow, .bg-green-gradient .in-page-hero-title, .bg-green-gradient .in-page-hero-eyebrow, .bg-blue .in-page-hero-title, .bg-blue .in-page-hero-eyebrow, .bg-blue-gradient .in-page-hero-title, .bg-blue-gradient .in-page-hero-eyebrow, .bg-blue-green-gradient .in-page-hero-title, .bg-blue-green-gradient .in-page-hero-eyebrow {
  color:var(--neutral-white);
}
.bg-light-blue .in-page-hero-title, .bg-light-blue .in-page-hero-eyebrow, .bg-light_blue .in-page-hero-title, .bg-light_blue .in-page-hero-eyebrow, .bg-light-gray .in-page-hero-title, .bg-light-gray .in-page-hero-eyebrow, .bg-light_gray .in-page-hero-title, .bg-light_gray .in-page-hero-eyebrow, .bg-white .in-page-hero-title, .bg-white .in-page-hero-eyebrow, .bg-transparent .in-page-hero-title, .bg-transparent .in-page-hero-eyebrow {
  color:var(--primary-blue-dark);
}
.bg-green, .bg-green-gradient {
  background-image:var(--green-gradient);
}
.bg-blue, .bg-blue-gradient {
  background-image:var(--blue-gradient);
}
.bg-blue-green-gradient{
  background-image:var(--blue-green-gradient);
}
.bg-light-blue, .bg-light_blue {
  background-color:var(--tint-dark-blue);
}
.bg-light-blue .in-page-hero-title, .bg-light-blue .in-page-hero-eyebrow, .bg-light_blue .in-page-hero-title, .bg-light_blue .in-page-hero-eyebrow {
  color:var(--primary-blue-dark);
}
.bg-light-gray, .bg-light_gray {
  background-color:var(--neutral-gray-5);
}
.bg-white {
  background-color:var(--neutral-white);
}
.bg-transparent {
  background-color:var(--neutral-transparent);
}
.in-page-hero-inner {
  display:flex;
  flex-direction:column-reverse;
  padding-top:2rem;
  padding-bottom:2rem;
}
@media (min-width: 1024px) {
  .in-page-hero-inner {
    flex-direction:row;
  }
  .in-page-hero-inner {
    padding-top:4rem;
    padding-bottom:4rem;
  }
}
@media (min-width: 768px) {
  .in-page-hero-inner.is-flipped {
    flex-direction:row-reverse;
  }
}
.in-page-hero-image {
  margin-bottom:1.5rem;
}
@media (min-width: 1024px) {
  .in-page-hero-image {
    margin-bottom:0px;
  }
}
@media (min-width: 1280px) {
  .in-page-hero-image {
    min-width:500px;
  }
}
@media (min-width: 1360px) {
  .in-page-hero-image {
    min-width:600px;
  }
}
@media (min-width: 2180px) {
  .in-page-hero-image {
    min-width:750px;
  }
}
@media (min-width: 1024px) {
  .in-page-hero-image.margin-right {
    margin-right:1.25rem;
  }
}
@media (min-width: 1280px) {
  .in-page-hero-image.margin-right {
    margin-right:3.5rem;
  }
}
@media (min-width: 1024px) {
  .in-page-hero-image.margin-left {
    margin-left:1.25rem;
  }
}
@media (min-width: 1280px) {
  .in-page-hero-image.margin-left {
    margin-left:3.5rem;
  }
}
.in-page-hero-title, .in-page-hero-title h1 {
  margin-bottom:1rem;
  margin-top:0px;
  overflow-wrap:break-word;
}
@media (min-width: 768px) {
  .in-page-hero-title, .in-page-hero-title h1 {
    overflow-wrap:normal;
    word-break:normal;
  }
}
.in-page-hero-title, .in-page-hero-title h1 {
  font-family:var(--ff-display);
  font-weight:var(--fw-bold);
  font-size:var(--fs-4xl);
  line-height:var(--lh-4xl);
}
@media (min-width: 1024px) {
  .in-page-hero-title, .in-page-hero-title h1 {
    font-size:var(--fs-h1-medium);
    line-height:var(--lh-h1-medium);
  }
}
@media (min-width: 1280px) {
  .in-page-hero-title, .in-page-hero-title h1 {
    font-size:var(--fs-h1);
    line-height:var(--lh-h1);
  }
}
.in-page-hero-title,
.in-page-hero-title h1{
  line-height:var(--lh-h1);
}
@media (min-width: 1024px){
  .in-page-hero-title,
  .in-page-hero-title h1{
    line-height:var(--lh-h1-medium);
  }
}
@media (min-width: 1280px){
  .in-page-hero-title,
  .in-page-hero-title h1{
    line-height:var(--lh-5xl);
  }
}
[cloned-slot-name='cta-links'] > div {
  margin-left:-0.25rem;
  margin-right:-0.25rem;
  width:100%;
  flex-wrap:wrap;
}
@media (min-width: 1024px) {
  [cloned-slot-name='cta-links'] > div {
    display:flex;
  }
}
[cloned-slot-name='cta-links'] ghs-button {
  padding-left:0.25rem;
  padding-right:0.25rem;
  padding-bottom:0.5rem;
}
.in-page-hero-eyebrow {
  position:relative;
  margin-bottom:0.75rem;
  display:inline-block;
  font-size:var(--fs-lg);
  line-height:var(--lh-lg);
  font-weight:var(--fw-medium);
}
@media (min-width: 1024px) {
  .in-page-hero-eyebrow {
    font-size:var(--fs-2xl);
    line-height:var(--lh-2xl);
  }
}
.in-page-hero-eyebrow{
  z-index:1;
}
.in-page-hero-eyebrow slot:after {
  background-color:var(--primary-blue-dark);
}
.in-page-hero-eyebrow slot:after{
    z-index:-1;
    position:absolute;
    height:6px;
    margin-left:-3%;
    content:'';
    right:0;
    width:106%;
    color:#000;
    left:0;
    bottom:3px;
  }
:host([cta-position='top']) .in-page-hero-inner {
  flex-direction:column;
}
@media (min-width: 1024px) {
  :host([cta-position='top']) .in-page-hero-inner {
    flex-direction:row;
  }
}
@media (min-width: 1024px) {
  :host([cta-position='top']) .in-page-hero-inner.is-flipped {
    flex-direction:row-reverse;
  }
}
:host([cta-position='top']) .in-page-hero-ctas {
  padding-bottom:1rem;
}
:host([cta-position='top']) .in-page-hero-ctas ghs-button {
  padding-left:0.5rem;
  padding-right:0.5rem;
}
:host([cta-position='top']) .in-page-hero-ctas ghs-button {
  padding-bottom:1rem;
}
`;